import { render } from "./Overview.vue?vue&type=template&id=39a565af"
import script from "./Overview.vue?vue&type=script&lang=ts"
export * from "./Overview.vue?vue&type=script&lang=ts"
script.render = render

export default script